// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form_pop.contrast{max-width:230px}.form_pop.contrast .el-select-dropdown__item{word-break:break-all;white-space:pre-wrap;height:auto;line-height:16px;margin-bottom:10px;padding:0 15px}", ""]);
// Exports
module.exports = exports;
